import { render, staticRenderFns } from "./choiceTable.vue?vue&type=template&id=9fa7b114&"
import script from "./choiceTable.vue?vue&type=script&lang=js&"
export * from "./choiceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports